import flatpickr from "flatpickr";
import flatpickrLanguages from "flatpickr/dist/l10n";
import { initGlide } from "./modules/common/glide"
import { initAutocomplete } from "./modules/frontv2/Autocomplete";
import { initMobileMenu } from "./modules/common/mobile-menu";
import { getUserLanguage } from "./modules/utils";
import { initGoogleEcommerce } from "./modules/google_ecommerce";
import { initFormValidation } from "./modules/common/form-validation";
import MobileMenu from "./modules/frontv2/MobileMenu";
import MobileSearch from "./modules/frontv2/MobileSearch";
import Wish from "./modules/frontv2/Wish";
import Modal from "./modules/frontv2/Modal";
import * as Sentry from "@sentry/browser";
import { initCommon } from "./modules/common/common";
import { initLinkingSeoBlock } from "./modules/frontv2/init-home-seo-block";
import { initSwiper } from "./modules/common/init-swiper";
import { initScrollToTop } from "./modules/frontv2/ScrollToTop";
import { initDrops } from "./modules/common/drop";
import { onClickLoadMoreExperiences } from "./modules/frontv2/Search/load-more-experiences-results";
import { initSearch } from "./modules/search";

document.addEventListener("DOMContentLoaded", () => {
  // Init Sentry JS
  if(document.body.dataset.env === 'prod') {
    Sentry.init({ dsn: 'https://b14c92e307604f4f8f454ebdd3eab1ef@sentry.io/1441102' });
  }

  flatpickr.localize(flatpickrLanguages[getUserLanguage()]);

  initCommon();

  //init glide (carousel)
  initGlide();

  //Dropdowns and dropups
  initDrops();

  //All search page logic
  const search = document.getElementById("searchPage");
  if(search){
    initSearch();
  }

  //Search bar logic (algolia) on top of the page
  initAutocomplete();

  //Mobile menu
  initMobileMenu();

  //Mobile menu logic
  new MobileMenu();

  //Mobile popup search logic
  new MobileSearch();

  Wish.bindWishButtons();

  //Analytics
  initGoogleEcommerce();

  Modal.bindAllModals();

  initFormValidation();

  //for search page results
  initSwiper();
  initLinkingSeoBlock();
  initScrollToTop();
  onClickLoadMoreExperiences();
});
